import React from 'react';
import Modal from '../common/Modal';

const METHODS = ['bank_transfer','cheque','cash','upi','neft','rtgs'];

export default function PaymentModal({ state, setState, onSave }) {
  if (!state.open) return null;
  return (
    <Modal
      open={state.open}
      onClose={() => setState(p => ({ ...p, open: false }))}
      title="Record Payment"
      footer={<>
        <button className="btn btn-secondary" onClick={() => setState(p => ({ ...p, open: false }))}>Cancel</button>
        <button className="btn btn-primary" onClick={onSave} disabled={state.saving}>
          {state.saving ? 'Saving…' : 'Record Payment'}
        </button>
      </>}
    >
      {state.error && (
        <div className="alert alert-error" style={{ marginBottom: 12 }}>{state.error}</div>
      )}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        {state.order && (
          <div style={{ padding: '8px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 6, fontSize: 13, color: '#475569' }}>
            Order <b>{state.order.order_number}</b> &nbsp;·&nbsp; {state.order.client_name}
            &nbsp;·&nbsp; Total: <b>{state.order.currency} {Number(state.order.total).toFixed(2)}</b>
          </div>
        )}
        <div className="form-row">
          <div className="form-group" style={{ flex: 1 }}>
            <label className="form-label">Amount *</label>
            <input className="form-control" type="number" min="0.01" step="0.01"
              value={state.amount}
              onChange={e => setState(p => ({ ...p, amount: e.target.value }))} autoFocus />
          </div>
          <div className="form-group" style={{ flex: 1 }}>
            <label className="form-label">Payment Date *</label>
            <input className="form-control" type="date"
              value={state.date}
              onChange={e => setState(p => ({ ...p, date: e.target.value }))} />
          </div>
        </div>
        <div className="form-group">
          <label className="form-label">Payment Method</label>
          <select className="form-control"
            value={state.method}
            onChange={e => setState(p => ({ ...p, method: e.target.value }))}>
            {METHODS.map(m => (
              <option key={m} value={m}>{m.replace('_', ' ').toUpperCase()}</option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label className="form-label">Reference / UTR / Cheque No.</label>
          <input className="form-control" placeholder="e.g. UTR123456"
            value={state.reference}
            onChange={e => setState(p => ({ ...p, reference: e.target.value }))} />
        </div>
        <div className="form-group">
          <label className="form-label">Notes</label>
          <input className="form-control" placeholder="Optional"
            value={state.notes}
            onChange={e => setState(p => ({ ...p, notes: e.target.value }))} />
        </div>
      </div>
    </Modal>
  );
}
